import { getPersonType, PersonType, QUERY_RESPONSE_PERSON_TYPES } from "@whatslly/types/Person";
import type { TFunction } from "i18next";
import { UserType } from "@whatslly/types/User";
import { AppIds, LoginProviderType } from "@whatslly/types/LoginProviderType";
import { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";

export const getPersonTypeText = (personType: string, t: TFunction, user?: UserType, accRecordTypeId?: string, isPersonAccount?: boolean) => {
  const type = (() => {
    if (accRecordTypeId && user && user.recordTypeNames) {
      const foundName = Object.values(user.recordTypeNames).find((m) => m && m[accRecordTypeId]);
      if (foundName && foundName[accRecordTypeId]) return foundName[accRecordTypeId];
    }

    if (accRecordTypeId && user && user.subtypes && Object.keys(user.subtypes).length > 0) {
      const selectedSubtype = Object.keys(user.subtypes).find((st) => st.includes(accRecordTypeId));
      if (selectedSubtype) {
        return user.subtypes[selectedSubtype];
      }
    }
    return personType;
  })();
  if (type === QUERY_RESPONSE_PERSON_TYPES.CONTACT) {
    return t("entity_contact");
  }
  if (type === QUERY_RESPONSE_PERSON_TYPES.LEAD) {
    return t("entity_lead");
  }
  if (type === QUERY_RESPONSE_PERSON_TYPES.USER) {
    return t("entity_sf_user");
  }
  if (type === QUERY_RESPONSE_PERSON_TYPES.UNKNOWN) {
    return t("entity_unknown");
  }
  if (type === QUERY_RESPONSE_PERSON_TYPES.ACCOUNT && !isPersonAccount) {
    return t("entity_account");
  }
  if (type === QUERY_RESPONSE_PERSON_TYPES.BLACKLISTED) {
    return t("entity_blacklisted");
  }
  return type || t("entity_unknown");
};

export const companyOrAccountName = (person: PersonType): string | undefined => {
  if (person.type === QUERY_RESPONSE_PERSON_TYPES.LEAD && (person.Company || person.companyname)) {
    return person.Company || person.companyname;
  }
  if (person.type === QUERY_RESPONSE_PERSON_TYPES.CONTACT && person.Account?.Name) {
    return person.Account.Name as string;
  }

  return undefined;
};

export const buildAddressStringFromPersonField = (value: Record<string, string>) => {
  const postalCodeLabelPrefix = value.state ? " " : "";
  const stateAndPostalCode = `${value.state ? value.state : ""}${value.postalCode ? `${postalCodeLabelPrefix}${value.postalCode}` : ""}`;
  const addArr = [value.street, value.city, stateAndPostalCode, value.country].filter(Boolean);

  return addArr.join(", ").replaceAll('"', "").replaceAll("'", "").replaceAll("\n", ",").replaceAll("\t", "");
};

export const getLoginProviderText = (loginProvider: LoginProviderType) => {
  if (loginProvider === AppIds.MICROSOFT_DYNAMICS) {
    return "Microsoft Dynamics";
  }
  if (loginProvider === AppIds.HUBSPOT) {
    return "Hubspot";
  }
  return "Salesforce";
};

export const getViewInText = (loginProvider: LoginProviderType, t: TFunction) => {
  return `${t("actions_view_in")} ${getLoginProviderText(loginProvider)}`;
};

export const getPersonTypeAndText: ({ person, user, t }: { person: PersonType; t: TFunction; user?: UserType }) => {
  typeText: string;
  type: "Contact" | "Lead" | "User" | "Manager" | "Unknown" | "Account" | "Person Account" | "Blacklisted";
} = ({ person, user, t }: { person: PersonType; t: TFunction; user?: UserType }) => {
  return {
    type: getPersonType(person),
    typeText: getPersonTypeText(person.type, t, user, person.RecordTypeId, (person as unknown as Record<string, boolean>).IsPersonAccount),
  };
};
export const getLoginProviderIcon = (loginProvider: LoginProviderType): { iconName: TuvisIconNamesType; iconText: string } => {
  switch (loginProvider) {
    case AppIds.MICROSOFT_DYNAMICS:
      return {
        iconName: "microsoft-dynamics",
        iconText: "Dynamics",
      };

    case AppIds.SALESFORCE:
      return {
        iconName: "salesforce",
        iconText: "Salesforce",
      };

    default:
      return {
        iconName: "salesforce",
        iconText: "Salesforce",
      };
  }
};
